import React, { useState, useCallback, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { EmployeeActivityApportionmentFragment } from '@rd-web-markets/shared/dist/financialSection/employeeActivity/EmployeeActivityApportionmentFragment';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util/';
import { StateSelect } from '../../util';
export const EmployeeActivityRow = _ref => {
  let {
    index,
    claim,
    claimEmployees,
    refreshClaim,
    setClaimEmployees,
    claimEmployeesService,
    handleError,
    claimEmployeeRndApportionmentsService
  } = _ref;
  const claimEmployee = useMemo(() => {
    return {
      ...claimEmployees[index]
    };
  }, [claimEmployees, index]);
  const [hasError, setHasError] = useState(false);
  const dispatch = useDispatch();
  const updateEmployees = useCallback(employee => {
    const newEmployees = [...claimEmployees];
    newEmployees[index] = {
      ...employee
    };
    setClaimEmployees([...newEmployees]);
  }, [claimEmployees, index, setClaimEmployees]);
  const handleApportionmentChange = useCallback((employee, apportionment) => {
    const oldApportionment = employee.claim_employee_rnd_apportionments.find(a => a.claim_project_report_id === apportionment.claim_project_report_id);
    const index = employee.claim_employee_rnd_apportionments.indexOf(oldApportionment);
    const newApportionments = [...employee.claim_employee_rnd_apportionments];
    if (index === -1) {
      newApportionments.push(apportionment);
    } else {
      newApportionments[index] = {
        ...apportionment
      };
    }
    updateEmployees({
      ...employee,
      claim_employee_rnd_apportionments: newApportionments
    });
  }, [updateEmployees]);
  const handleChange = useCallback(event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    claimEmployee[event.target.name] = value;
    updateEmployees(claimEmployee);
  }, [updateEmployees, claimEmployee]);
  const saveChange = useCallback(() => {
    let method;
    if (claimEmployee.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    claimEmployeesService[method](claimEmployee).then(claimEmployee => {
      setHasError(false);
      updateEmployees(claimEmployee);
      refreshClaim();
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [updateEmployees, refreshClaim, claimEmployee, dispatch]);
  return /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: true,
    name: "name",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: true,
    name: "number",
    type: "text",
    placeholder: "Please enter employees number",
    size: "sm"
  })), claim.claim_group.project_methodology === 'project_basis' ? claim.claim_group.claim_project_reports.map((report, reportIndex) => {
    const apportionment = claimEmployee.claim_employee_rnd_apportionments.find(a => {
      return a.claim_employee_id === claimEmployee.id && a.claim_project_report_id === report.id;
    }) || {
      claim_employee_id: claimEmployee.id,
      claim_project_report_id: report.id
    };
    return /*#__PURE__*/React.createElement(EmployeeActivityApportionmentFragment, {
      key: reportIndex,
      claim: claim,
      apportionment: apportionment,
      handleApportionmentChange: apportionment => handleApportionmentChange(claimEmployee, apportionment),
      claimEmployeeRndApportionmentsService: claimEmployeeRndApportionmentsService
    });
  }) : null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e),
    onBlur: saveChange,
    object: claimEmployee,
    disabled: claim.claim_group.project_methodology !== 'employee_basis',
    name: "rnd_apportionment",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    disabled: true,
    object: claimEmployee,
    name: "wage",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    disabled: true,
    object: claimEmployee,
    name: "rnd_amount",
    type: "text",
    size: "sm"
  })));
};